// ============================================================
// schema-helpers.js — JSON-LD Schema Injection Utilities
// Place at: src/utils/schema-helpers.js
// ============================================================

// ─── LOCALBUSINESS SCHEMA (inject on homepage only) ───────
export function injectLocalBusinessSchema() {
  removeSchema('localbusiness');
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://clickonemsp.ca/#business",
    "name": "Click One MSP",
    "url": "https://clickonemsp.ca",
    "telephone": "+17785626930",
    "email": "info@clickonemsp.com",
    "description": "Managed IT services, cybersecurity, and Microsoft 365 support for Vancouver and BC businesses.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1771 Robson Street",
      "addressLocality": "Vancouver",
      "addressRegion": "BC",
      "postalCode": "V6G 3B7",
      "addressCountry": "CA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 49.2827,
      "longitude": -123.1207
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "priceRange": "$$",
    "areaServed": [
      "Vancouver, BC", "Burnaby, BC", "Surrey, BC",
      "Richmond, BC", "Coquitlam, BC", "Abbotsford, BC",
      "Delta, BC", "Langley, BC", "New Westminster, BC"
    ],
    "sameAs": [
      "https://www.facebook.com/clickonemsp",
      "https://www.instagram.com/clickonemsp",
      "https://www.linkedin.com/company/clickonemsp"
    ]
  };
  injectSchema(schema, 'localbusiness');
}

// ─── ARTICLE SCHEMA (blog posts & case studies) ──────────
export function injectArticleSchema(post) {
  removeSchema('article');
  const url = post.url || ('https://clickonemsp.ca/post/' + post.slug);
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": post.title,
    "description": post.excerpt || post.title,
    "datePublished": post.publishedAt || post.createdAt,
    "dateModified": post.updatedAt || post.publishedAt || post.createdAt,
    "author": {
      "@type": "Organization",
      "name": "Click One MSP",
      "url": "https://clickonemsp.ca"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Click One MSP",
      "logo": {
        "@type": "ImageObject",
        "url": "https://clickonemsp.ca/clickonemsp-logo.png"
      }
    },
    "url": url,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    }
  };
  if (post.image || post.featuredImage) {
    schema.image = post.image || post.featuredImage;
  }
  injectSchema(schema, 'article');
}

// ─── HELPERS ─────────────────────────────────────────────
function injectSchema(schemaObj, key) {
  const el = document.createElement('script');
  el.type = 'application/ld+json';
  el.setAttribute('data-schema', key);
  el.text = JSON.stringify(schemaObj, null, 2);
  document.head.appendChild(el);
}

function removeSchema(key) {
  const existing = document.querySelector('script[data-schema="' + key + '"]');
  if (existing) existing.remove();
}
